"use strict";
class Invariantor {
    constructor(supplierCustomerToEnsure) {
        this.supplierCustomerToEnsure = supplierCustomerToEnsure;
    }
    ensureVATNumber() {
        if (this.supplierCustomerToEnsure.organisationNumber &&
            this.supplierCustomerToEnsure.deliveryCountry === 'SE') {
            // eslint-disable-next-line prefer-regex-literals
            const regex = new RegExp('[-]', 'g');
            this.supplierCustomerToEnsure.VATNumber = `SE${this.supplierCustomerToEnsure.organisationNumber.replace(regex, '')}01`;
        }
        return this;
    }
    value() {
        return this.supplierCustomerToEnsure;
    }
}
module.exports = entity => {
    const ensured = new Invariantor(entity).ensureVATNumber().value();
    return ensured;
};
